<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      >
        <template #controls="{ row }">
          <div class="button-group-vertical">
            <router-link :to="`edit/${row.id}`">
              <el-button icon="el-icon-edit" size="mini"
                >Редактировать</el-button
              >
            </router-link>
            <router-link
              v-if="row.region === 'msk'"
              :to="`list/${row.id}/time-slots/`"
            >
              <el-button size="mini" @click="setCurrentContentId(row)"
                >Временные слоты</el-button
              >
            </router-link>
          </div>
        </template>
      </Table>
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import {
  getEvents as fetchData,
  deleteEvents as deleteRow,
} from "@/api/events";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "id",
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "Id",
    sortable: true,
  },
  {
    prop: "type",
    label: "Тип",
    type: "enum",
    alias: "content_type",
    sortable: false,
  },
  {
    prop: "preview",
    label: "Миниатюра",
    type: "preview",
    sortable: false,
  },
  {
    prop: "title",
    label: "Название",
    sortable: false,
  },
  {
    prop: "date",
    label: "Дата проведения",
    sortable: true,
  },
  {
    prop: "start_at",
    label: "Время начала",
    sortable: false,
  },
];

const regionObject = {
  prop: "city",
  label: "Регион",
  type: "enum",
  alias: "region",
  sortable: false,
};

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: [
        ...(this.$store.getters.isAbleToSeeRegions ? [regionObject] : []),
        ...columns,
      ],
      methods: {
        fetchData,
        deleteRow,
      },
    };
  },
};
</script>
